<template>
    <div id="app">
        <v-app>
            <router-view></router-view>
        </v-app>
    </div>
</template>

<script>
    export default {

    }
</script>

<style lang="stylus">
    @require 'assets/css/main'

</style>



// WEBPACK FOOTER //
// src/App.vue